import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import type { IBaseService } from './api.types';

export class BaseService implements IBaseService {
  #http: AxiosInstance;

  constructor(http: AxiosInstance) {
    this.#http = http;
  }

  setHeader(key: string, value: string) {
    delete this.#http.defaults.headers[key];
    delete this.#http.defaults.headers.common[key];
    this.#http.defaults.headers.common[key] = value;
  }

  get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.#http.get(url, config);
  }

  delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.#http.delete(url, config);
  }

  head<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.#http.head(url, config);
  }

  options<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.#http.options(url, config);
  }

  post<T>(url: string, payload?: unknown, config?: AxiosRequestConfig): Promise<T> {
    return this.#http.post(url, payload, config);
  }

  put<T>(url: string, payload?: unknown, config?: AxiosRequestConfig): Promise<T> {
    return this.#http.put(url, payload, config);
  }

  patch<T>(url: string, payload?: unknown, config?: AxiosRequestConfig): Promise<T> {
    return this.#http.patch(url, payload, config);
  }

  request<T>(config: AxiosRequestConfig): Promise<T> {
    if (!config) {
      throw new Error('Request config is required!');
    }
    return this.#http.request(config);
  }
}
